import script from "./Education_Level.vue?vue&type=script&setup=true&lang=js"
export * from "./Education_Level.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__